// extracted by mini-css-extract-plugin
export default {"container":"common_container__MLLdW","desc":"common_desc__pY-6l","form":"common_form__y9V7v"};